module.exports = __webpack_public_path__ + "img/setting_color_red.7e92f015.svg";